export default __webpack_public_path__ + "static/media/doctor8.c0ab6c11.jpg";